import { render, staticRenderFns } from "./sectionWiseScreen.vue?vue&type=template&id=75a73671&scoped=true"
import script from "./sectionWiseScreen.vue?vue&type=script&lang=js"
export * from "./sectionWiseScreen.vue?vue&type=script&lang=js"
import style0 from "./sectionWiseScreen.vue?vue&type=style&index=0&id=75a73671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a73671",
  null
  
)

export default component.exports